<template>
  <div class="block block-fx-shadow block-rounded block-themed block-mode-loading-refresh" :class="{'block-mode-loading': isProcessing}">
    <div class="block-header bg-gd-sea">
      <h3 class="block-title">{{ $t('users.online') }}</h3>
      <div class="block-options">
        <button type="button" class="btn-block-option" @click="onlineUsers()">
            <i class="si si-refresh"></i>
        </button>
      </div>
    </div>
    <div v-for="(user, index) in users" class="py-15 px-20 clearfix border-black-op-b justify-content-between align-items-center" :key="index">
      <i v-if="user.isOnline" class="fa fa-user-circle mr-5 fa-lg text-success"></i> {{user.fullname}}
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      users: [],
      isProcessing: false,
    };
  },
  mounted() {
    this.onlineUsers();
  },
  methods: {
    onlineUsers() {
      this.isProcessing = true;
      window.axios.get('/admin/users/online')
        .then((res) => {
          this.users = res.data.users;
        })
        .catch((err) => console.log(err))
        .finally(() => {
          this.isProcessing = false;
        });
    },
  },
};
</script>
